export default "__VITE_ASSET__BD7rW$fj__"